import { useState, useEffect } from 'react';
import { HiPuzzle, HiCheckCircle, HiRefresh } from 'react-icons/hi';

const COULEURS = ['bg-blue-500', 'bg-purple-500', 'bg-orange-500', 'bg-pink-500', 'bg-teal-500', 'bg-indigo-500'];

const melanger = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const ExerciceBlocs = ({ exercice }) => {
  const [blocs, setBlocs] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);
  const [resultat, setResultat] = useState(null); // null | 'bravo' | 'rate'

  const initialiser = () => {
    let m = melanger(exercice.blocs);
    // S'assurer que l'ordre initial n'est pas déjà le bon
    if (m.join('|') === exercice.blocs.join('|') && m.length > 1) {
      [m[0], m[1]] = [m[1], m[0]];
    }
    setBlocs(m);
    setResultat(null);
  };

  useEffect(() => { if (exercice?.blocs) initialiser(); }, [exercice]);

  if (!exercice?.blocs) return null;

  const deplacer = (de, vers) => {
    if (de === vers) return;
    const copie = [...blocs];
    const [bloc] = copie.splice(de, 1);
    copie.splice(vers, 0, bloc);
    setBlocs(copie);
    setResultat(null);
  };

  const verifier = () => {
    const ok = blocs.join('|') === exercice.blocs.join('|');
    setResultat(ok ? 'bravo' : 'rate');
  };

  return (
    <div className="bg-white border-2 border-purple-200 rounded-2xl shadow-sm overflow-hidden">
      <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center gap-3">
        <HiPuzzle className="text-white text-2xl" />
        <div>
          <h3 className="text-white font-bold">Défi blocs !</h3>
          <p className="text-purple-100 text-xs">Glisse les blocs dans le bon ordre, comme sur Scratch</p>
        </div>
      </div>

      <div className="p-6 space-y-4">
        <p className="text-sm font-semibold text-gray-700 bg-purple-50 border border-purple-100 rounded-xl p-3">
          🎯 {exercice.consigne}
        </p>

        <div className="space-y-2">
          {blocs.map((bloc, i) => (
            <div
              key={bloc}
              draggable
              onDragStart={() => setDragIndex(i)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => { deplacer(dragIndex, i); setDragIndex(null); }}
              className={`${COULEURS[exercice.blocs.indexOf(bloc) % COULEURS.length]} ${resultat === 'bravo' ? '!bg-green-500' : ''} text-white px-4 py-3 rounded-lg rounded-l-none border-l-8 border-black/20 font-medium text-sm cursor-grab active:cursor-grabbing select-none shadow-md hover:scale-[1.01] transition-transform flex items-center gap-3`}
            >
              <span className="text-white/60 font-black">⠿</span>
              {bloc}
            </div>
          ))}
        </div>

        {resultat === 'bravo' && (
          <div className="text-center p-4 bg-green-50 border border-green-200 rounded-xl">
            <div className="text-4xl animate-bounce">🎉</div>
            <p className="text-green-700 font-bold mt-1">Bravo, algorithme parfait ! Tu programmes comme un pro !</p>
          </div>
        )}
        {resultat === 'rate' && (
          <div className="text-center p-4 bg-amber-50 border border-amber-200 rounded-xl">
            <div className="text-3xl">🤔</div>
            <p className="text-amber-700 font-bold mt-1">Pas encore ! Relis les blocs : que faut-il faire en premier ?</p>
          </div>
        )}

        <div className="flex gap-3">
          <button onClick={verifier} className="flex-1 bg-gradient-to-r from-purple-600 to-pink-500 text-white py-3 rounded-xl font-bold hover:scale-[1.01] transition-transform shadow-lg shadow-purple-500/20 inline-flex items-center justify-center gap-2">
            <HiCheckCircle className="text-lg" /> Vérifier mon programme
          </button>
          <button onClick={initialiser} className="px-4 py-3 rounded-xl border-2 border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors" title="Mélanger à nouveau">
            <HiRefresh className="text-lg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExerciceBlocs;
